import { MentionData } from '@draft-js-plugins/mention'
import { Employee } from './types'

export const convertEmployeesToMentions = (employees: Employee[]): MentionData[] => {
  return employees.map((employee) => ({
    name: ` ${employee.full_name_i18n}`,
    avatar: employee.avatar_thumb,
    id: employee.id.toString(),
    title: employee.job_title_name_i18n,
  }))
}
